import clsx from "clsx";
import React from "react";
import useRolesVisibility from "../../common/roles/useRolesVisibility";
import { RequiredRoles } from "../criteria/components/common/requiredRoles";

interface PresetProps {
	title: string;
	content: string;
	link?: string;
	linkName?: string;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
	error?: string;
	isVertical?: boolean;
	children?: React.ReactNode;
	requiredRoles?: RequiredRoles;
}

export function Preset({
	children,
	content,
	error,
	isVertical = false,
	link = "#",
	linkName = "Search",
	onClick,
	requiredRoles,
	title,
}: PresetProps) {
	const { hasRequiredRoles } = useRolesVisibility(requiredRoles);
	const presetClasses = clsx("preset", { vertical: isVertical });
	const actionClasses = clsx("preset__actions", {
		error,
		vertical: isVertical,
	});

	if (!hasRequiredRoles) {
		return null;
	}

	return (
		<article className={presetClasses}>
			<div className="preset__content square-wrapper">
				<h3 className="title with-square">{title}</h3>
				<p>{content}</p>
			</div>

			<div className={actionClasses}>
				{children}
				<a className="btn btn--primary" href={link} onClick={onClick}>
					{linkName}
				</a>
			</div>
		</article>
	);
}
